import { Input } from "@aidkitorg/component-library";
import { useCallback } from "react";
import { useLocalizedStrings } from "../../../../Localization";
import { FilterWrapper } from "../../../components/FilterWrapper";

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const L = useLocalizedStrings();
  const handleStartDateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onStartDateChange(e.target.value);
  }, [onStartDateChange]);

  const handleEndDateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onEndDateChange(e.target.value);
  }, [onEndDateChange]);

  return (
    <FilterWrapper label={L.admin_panel.audit_logs.date_range}>
      <div className="flex flex-col gap-1.5 items-start sm:flex-row sm:items-center">
        <div className="flex-1">
          <Input
            type="date"
            value={startDate}
            onChange={handleStartDateChange}
            label={L.admin_panel.audit_logs.from}
            showLabel={false}
          />
        </div>
        <div className="text-sm">{L.admin_panel.audit_logs.to}</div>
        <div className="flex-1">
          <Input
            type="date"
            value={endDate}
            onChange={handleEndDateChange}
            label={L.admin_panel.audit_logs.to}
            showLabel={false}
          />
        </div>
      </div>
    </FilterWrapper>
  );
};
